<template>
  <div class="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop" id="kt_footer">
    <div class="kt-footer__copyright">
      {{year}}&nbsp;&copy;&nbsp;
      <a
        href="/"
        class="kt-link"
      >{{$t('WebsiteName')}} ({{$t("updated on")}} {{version}})</a>
    </div>
    <div class="kt-footer__menu">
      <a
        href="/apireference.html"
        target="_blank"
        class="kt-footer__menu-link kt-link"
      >{{$t('API Reference')}}</a>
      <!--a href="/" target="_blank" class="kt-footer__menu-link kt-link">{{$t('About')}}</a>
      <a href="/" target="_blank" class="kt-footer__menu-link kt-link">{{$t('Team')}}</a>
      <a href="/" target="_blank" class="kt-footer__menu-link kt-link">{{$t('Contact')}}</a-->
    </div>
  </div>
</template>

<script>
export const toDate = st => {
  let date_ob;
  if (st) {
    date_ob = new Date(st);
  } else {
    date_ob = new Date();
  }

  // current date
  // adjust 0 before single digit date
  let date = ("0" + date_ob.getDate()).slice(-2);

  // current month
  let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);

  // current year
  let year = date_ob.getFullYear();

  let hours = ("0" + date_ob.getHours()).slice(-2);
  let minutes = ("0" + date_ob.getMinutes()).slice(-2);
  let seconds = ("0" + date_ob.getSeconds()).slice(-2);
  return `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
};

export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  computed: {
    version() {
      return toDate(process.env.VERSION);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
